/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import { Container, Row, Col, Card, CardBody } from "../components/ui";
import { Link } from "react-router-dom";
import ReadMore from "../components/common/ReadMore";
import { getPublishers } from "../api";
import PageTitle from "../components/common/PageTitle";
import { DotLoader } from "react-spinners";

class Education extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      publishers: [],
      loading: false
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true });
    const publishers = await getPublishers();
    this.setState({ publishers: publishers.data, loading: false });
  };

  render() {
    return this.state.loading ? (
      <div className="mainLoaderBlock">
        <DotLoader color="#36d7b7" />
        <label style={{ marginTop: 30 }}>Loading your content...</label>
      </div>
    ) : (
      <Container fluid className="main-content-container px-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" subtitle="" className="text-sm-left" />
        </Row>
        <Row>
          {this.state.publishers
            .filter(p => p.isHidden === false)
            .map((publisher, idx) => (
              <Col lg="3" md="6" sm="12" className="mb-4" key={idx}>
                <Card small className="card-post card-post-publisher">
                  {publisher.isFeaturedContributor && (
                    <h4 class="ribbon">Featured Contributor</h4>
                  )}
                  <div className="analyst-profile d-flex">
                    <Link
                      to={`/analyst/${publisher.slug}`}
                      className="card-post__author-avatar "
                      style={{
                        backgroundImage: `url('${publisher.avatar.small}')`
                      }}
                    ></Link>
                    <Link to={`/analyst/${publisher.slug}`}>
                      {publisher.name}
                    </Link>
                  </div>
                  <CardBody>
                    <h5 className="card-title">
                      <a href="#" className="text-fiord-blue">
                        {publisher.title}
                      </a>
                    </h5>
                    {publisher && publisher.bio !== null ? (
                      <p className="card-text d-inline-block mb-3">
                        <ReadMore
                          text={publisher.bio}
                          min={330}
                          ideal={340}
                          max={350}
                          readMoreText="Read more..."
                        />
                      </p>
                    ) : (
                      ""
                    )}
                  </CardBody>
                </Card>
              </Col>
            ))}
        </Row>
      </Container>
    );
  }
}

export default Education;
